import { Component, OnInit, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EdpService } from '../services/edp.service';
import {
  NgbDateStruct,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbCalendar,
  NgbInputDatepickerConfig,
} from '@ng-bootstrap/ng-bootstrap';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { Location } from '@angular/common';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  selector: 'app-nueva-sesion',
  templateUrl: './nueva-sesion.component.html',
  styleUrls: ['./nueva-sesion.component.css'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    NgbInputDatepickerConfig,
  ],
  standalone: false,
})
export class NuevaSesionComponent implements OnInit {
  state$: Observable<object> | undefined;

  // Datos sesion individual
  sesionIndividual = {
    se_fecha_sesion: '',
    numero_sesion: '',
    se_proxima_sesion: '',
    carrera: '',
    grupo: '',
    se_cve_alumno: '',
    alumno: '',
    alu_grupo: '',
    alu_carrera: '',
    responsable: '',
    se_aspectos_trabajados: '',
    registrador: '',
    idSubgrupo: '',
    se_solicitador: '',
    se_cve_personal: '',
    se_nombre_solicitador: '',
    se_notas: '',
    se_fecha_registro: '',
    se_sesiones_aplica: '',
    se_asistio: '',
    se_tema: '',
  };

  icon1 = faCalendar;

  matricula: string = '';
  nombre: string = '';
  idGrupo: string = '';
  tutor: string = '';
  // Lista Personal
  personal: any = [];

  temas = [];
  selectedItems = [];

  fecha_sesion: string = this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
  hora_sesion: { hour: number; minute: number; second: number } | null = null;

  fecha_proxima_sesion: string = '';
  hora_proxima_sesion: { hour: number; minute: number; second: number } | null =
    null;

  constructor(
    private service: EdpService,
    private route: Router,
    private location: Location,
    private ngbCalendar: NgbCalendar,
    private dateAdapter: NgbDateAdapter<string>,
    config: NgbInputDatepickerConfig
  ) {
    config.minDate = { year: 2000, month: 1, day: 1 };
    config.maxDate = { year: 2099, month: 12, day: 31 };

    config.markDisabled = (date: NgbDateStruct) => {
      const weekendDays = [0, 6]; // Domingo es 0, Sábado es 6
      return weekendDays.includes(
        new Date(date.year, date.month - 1, date.day).getDay()
      );
    };
  }

  get today() {
    return this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
  }

  ngOnInit(): void {
    this.nombre = window.history.state.nombre;
    this.matricula = window.history.state.matricula;
    this.idGrupo = window.history.state.idGrupo;
    this.tutor = window.history.state.tutor;

    if (!this.idGrupo || !this.tutor) this.route.navigate(['/']);
    if (!this.matricula || !this.nombre)
      this.route.navigateByUrl('/alumnos', {
        state: { idGrupo: this.idGrupo, tutor: this.tutor },
      });

    if (this.service.comprobarSesion()) {
      this.service
        .obtenerDatosAlumno(
          sessionStorage.getItem('edpp-token'),
          this.idGrupo,
          this.matricula
        )
        .subscribe(
          async (data) => {
            if (data[0].Error) {
              if (data[0].Error.includes('caducado')) {
                alert('La sesión ha caducado.\nVuelve para iniciar sesión.');
                this.route.navigate(['/login']);
              } else {
                alert('No tienes permiso para acceder a la sección.');
                this.route.navigate(['/']);
              }
            } else {
              const datosPredefinidos = await data[0];
              this.sesionIndividual['carrera'] = datosPredefinidos['carrera'];
              this.sesionIndividual['grupo'] = datosPredefinidos['grupo'];
              this.sesionIndividual['responsable'] =
                datosPredefinidos['responsable'];
              this.sesionIndividual['registrador'] =
                datosPredefinidos['registrador'];
              this.sesionIndividual['numero_sesion'] =
                datosPredefinidos['numero_sesion'];
              this.sesionIndividual['alu_grupo'] =
                datosPredefinidos['alu_grupo'];
              this.sesionIndividual['alu_carrera'] =
                datosPredefinidos['alu_carrera'];
              this.sesionIndividual['alumno'] = this.nombre;
              this.sesionIndividual['se_cve_alumno'] = this.matricula;
              this.sesionIndividual['se_sesiones_aplica'] = '1';
              this.sesionIndividual['se_asistio'] = '1';

              this.sesionIndividual.idSubgrupo = this.idGrupo;
            }
          },
          (err) => {
            if (!err.ok)
              alert('Error del servidor: Vuelve a intentarlo más tarde.');
          }
        );

      this.service.obtenerListaPersonal().subscribe(async (data) => {
        this.personal = data;
      });

      this.service.obtenerTipoTema().subscribe(async (data: any) => {
        this.temas = data;
      });
    }
  }

  registrarSesionIndividual() {
    if (this.service.comprobarSesion()) {
      this.sesionIndividual['se_fecha_sesion'] = this.fecha_sesion
        ? this.formatDate(this.fecha_sesion, this.hora_sesion)
        : '';

      this.sesionIndividual['se_proxima_sesion'] = this.fecha_proxima_sesion
        ? this.formatDate(this.fecha_proxima_sesion, this.hora_proxima_sesion)
        : '';

      this.sesionIndividual.se_tema = this.selectedItems.toString();

      this.service
        .registraSesionIndividual(
          sessionStorage.getItem('edpp-token'),
          this.sesionIndividual
        )
        .subscribe(async (data) => {
          if (data[0].Error) {
            alert(`Error: ${data[0].Error}`);
          } else {
            alert('Correcto: La sesión se ha guardado');
            this.route.navigateByUrl('/sesion-individual', {
              state: {
                matricula: this.matricula,
                nombre: this.nombre,
                idGrupo: this.idGrupo,
                tutor: this.tutor,
              },
            });
          }
        });
    }
  }

  volverAAlumnos() {
    this.location.back();
  }

  handleChange(ev: any) {
    let key = ev.id;
    this.sesionIndividual[key as keysg] = ev.value;
  }

  formatDate(
    date: string,
    time: { hour: number; minute: number; second: number } | null
  ): string {
    if (time === null) {
      time = { hour: 0, minute: 0, second: 0 };
    }

    let [day, month, year] = date.split('-').map((num) => parseInt(num));

    if (year < 100) {
      year += 2000;
    }

    const combinedDate = new Date(
      Date.UTC(year, month - 1, day, time.hour, time.minute, time.second)
    );

    return combinedDate.toISOString().slice(0, 16);
  }

  toggleHabilitado(ev: any) {
    let key = ev.id;
    this.sesionIndividual[key as keysg] = ev.checked ? '1' : '0';
  }
}

const sesionIndividual = {
  se_fecha_sesion: '',
  numero_sesion: '',
  se_proxima_sesion: '',
  carrera: '',
  grupo: '',
  se_cve_alumno: '',
  alumno: '',
  alu_grupo: '',
  alu_carrera: '',
  responsable: '',
  se_aspectos_trabajados: '',
  registrador: '',
  idSubgrupo: '',
  se_solicitador: '',
  se_cve_personal: '',
  se_nombre_solicitador: '',
  se_notas: '',
  se_fecha_registro: '',
  se_sesiones_aplica: '',
  se_asistio: '',
  se_tema: '',
} as const;

type keysg = keyof typeof sesionIndividual;
